import React from 'react';
import './_combo-items.scss';
import Icon from '../../mweb/Icon/Icon';

const ComboItems = ({ title, items }) => {
  return (
    <div className="combo-items">
      <div className="combo-items--title">{title}</div>
      <div className="combo-items--item-container">
        {items.map(item => {
          const primaryImage = item.images.find(i => i.isPrimary);
          return (
            <div className="combo-items--item" key={item.skus[0].sku}>
              <Icon
                size={50}
                class="combo-items--item--image"
                src={primaryImage.url}
              />
              <div>
                <div className="combo-items--item--product-name">
                  {item.productName}
                </div>
                <div className="combo-items--item--product-quantity">
                  {item.skuQuantity}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComboItems;
